import NotAvailable from '../../components/fallback/NotAvailable'

const Bookmarks: React.FC = () => {
  return <NotAvailable title={'Bookmarks'} />
}

export default Bookmarks
